import { render } from "./TabError.vue?vue&type=template&id=5cf49b68&scoped=true"
import script from "./TabError.vue?vue&type=script&lang=js"
export * from "./TabError.vue?vue&type=script&lang=js"

import "./TabError.vue?vue&type=style&index=0&id=5cf49b68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf49b68"]])

export default __exports__